import React from 'react';
import { observer } from 'mobx-react';
import classnames from 'classnames';
import Text from '../../../../../../global/text/text';
import { OEToggle } from '../../../../../../global/oe-toggle/oe-toggle';
import { TConnectionItemDraggable } from './types';
import { getConnectionTemplateItemLabelText } from '../../../../../../../infrastructure/utils/connections.utils';

export type ConnectionTemplateConnectionsListItemProps = {
    item: TConnectionItemDraggable;
    enabled: boolean;
    inactive?: boolean;
    toggle: (index: number) => void;
    index: number;
};

export const ConnectionTemplateConnectionGroupConnectionsListItem = observer((props: ConnectionTemplateConnectionsListItemProps) => {
    const { enabled, item, toggle, index, inactive } = props;

    const toggleConnection = (): void => toggle(index);

    return (
        <div
            className={classnames('connections-list__item', { 'connections-list__item--disabled': !enabled })}
        >
            <Text tag='p' className='connections-list__item-title' message={getConnectionTemplateItemLabelText(item)} withEllipsis />
            <OEToggle isSelected={enabled} className='connections-list__item-toggle' onClick={toggleConnection} isDisabled={inactive} />
        </div>
    );
});
